import React from 'react';
import PropTypes from 'prop-types';

function Wrapper(props) {
    const { children } = props;
    return (
        <div className="kbe-header-user-preferences-wrapper">
            {children}
        </div>
    );
}

Wrapper.propTypes = { children: PropTypes.node.isRequired };

export default Wrapper;
